import React from 'react';

const MoreInfo = () => (
  <svg
    width="4"
    height="18"
    viewBox="0 0 4 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse cx="2" cy="8.96036" rx="2" ry="1.99161" fill="#434343" />
    <ellipse cx="2" cy="15.933" rx="2" ry="1.99161" fill="#434343" />
    <ellipse cx="2" cy="1.99161" rx="2" ry="1.99161" fill="#434343" />
  </svg>
);

export default MoreInfo;
